import { createSlice, PayloadAction } from '@reduxjs/toolkit';
/* eslint-disable  import/no-cycle */
import { RootState } from 'store/rootReducer';

type Notification = {
  message: string;
  severity: 'error' | 'success' | 'info' | 'warning' | undefined;
};
const initialState: Notification = {
  severity: undefined,
  message: ''
};

const appNotificationsSlice = createSlice({
  initialState,
  name: 'appNotifications',
  reducers: {
    resetAppNotification: state => {
      state.message = '';
    },
    setAppNotification: (
      state,
      { payload }: PayloadAction<{ message: string; severity: 'error' | 'success' | 'info' | 'warning' | undefined }>
    ) => {
      const { severity, message } = payload;
      state.severity = severity;
      state.message = message;
    }
  }
});

const { actions, reducer } = appNotificationsSlice;
export { reducer as appNotifications };
export const { resetAppNotification, setAppNotification } = actions;

export const getNotification = (state: RootState) => state.appNotifications;
